import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRsvpAnswersIframe = loadable(() => import(/* webpackChunkName: "content/rsvp/iframe" */ '.'));
